import React, { useState, useEffect } from 'react';
import { addDays } from 'date-fns';
import './GlobalTimer.css'; // We will create this file next

function GlobalTimer({ profile }) {
																			
  const [now, setNow] = useState(() => new Date());

  // This is the "ticker" that updates the time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);
    
    // Cleanup the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  // If there's no profile or the course hasn't started, render nothing
  if (!profile?.course_start_date) {
    return null;
  }

  // --- Date & Progress Calculations ---
  const startDate = new Date(profile.course_start_date);
  const endDate = addDays(startDate, 5); // The 5-day (120-hour) end time
  
  const totalDurationMs = endDate.getTime() - startDate.getTime();
  const timeElapsedMs = now.getTime() - startDate.getTime();
  const timeRemainingMs = endDate.getTime() - now.getTime();

  // --- Clamp values for display ---
  // This ensures the bar doesn't go below 0% or above 100%
  const clampedElapsedMs = Math.max(0, Math.min(timeElapsedMs, totalDurationMs));
  const clampedRemainingMs = Math.max(0, Math.min(timeRemainingMs, totalDurationMs));
  const progressPercent = (clampedElapsedMs / totalDurationMs) * 100;

  // --- Format the display text ---
			
					 
					  
				  

  // 1. "Hours Gone" label for the marker
  const hoursGone = (clampedElapsedMs / (1000 * 60 * 60)).toFixed(1);
		   
				  

  // 2. "HH:MM:SS" text for remaining time
  const totalHoursLeft = Math.floor(clampedRemainingMs / (1000 * 60 * 60));
  const minutesLeft = Math.floor((clampedRemainingMs % (1000 * 60 * 60)) / (1000 * 60));
  const secondsLeft = Math.floor((clampedRemainingMs % (1000 * 60)) / 1000);

  const formattedTimeLeft = 
    `${String(totalHoursLeft).padStart(2, '0')}:` +
    `${String(minutesLeft).padStart(2, '0')}:` +
    `${String(secondsLeft).padStart(2, '0')}`;

  // 3. Set the final label
  const displayLabel = timeRemainingMs <= 0 ? "COURSE COMPLETE" : "HRS LEFT";

  // Before the course starts, show a "Not Started" message
  if (now < startDate) {
    return (
      <div className="global-timer-container">
        <span className="global-timer-journey">Journey:</span>
        <div className="global-timer-track">
          <div className="global-timer-progress" style={{ width: '0%' }}></div>
          <div className="global-timer-marker" style={{ left: '0%' }}>
            <span className="global-timer-label">0.0 HRS GONE</span>
          </div>
        </div>
        <div className="global-timer-display">NOT STARTED</div>
      </div>
    );
  }

  // --- Render the Timer Bar ---
						
																
						
		  
					   
																  
					  
   

																			  
												  
													
	 

							
																					
	

  return (
    <div className="global-timer-container">
      <span className="global-timer-journey">Journey:</span>
							   
			 
      <div className="global-timer-track">
        <div 
          className="global-timer-progress" 
          style={{ width: `${progressPercent}%` }}
        ></div>
        <div 
          className="global-timer-marker" 
          style={{ left: `${progressPercent}%` }}
        >
          <span className="global-timer-label">{hoursGone} HRS GONE</span>
        </div>
      </div>
      <div className="global-timer-display">
        {formattedTimeLeft} {displayLabel}
      </div>
	  
	
			
			 
   
					
	 
   
		   
			
   
    </div>
  );
}

export default GlobalTimer;